import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { initShopifyDashboard, fetchAnalytics, getDefaultAnalyticsDateRange } from 'controllers/shopifyDashboard'
import { gotoEditor, publishAndActivate } from 'controllers/shopifyApp'
import { setAnalyticsDatesRange } from 'actions/shopifyAnalyticsAC'

import { DisplayText, Banner, Spinner, TextContainer } from '@shopify/polaris'
import { EmbeddedApp } from '@shopify/polaris/embedded'
import ShopifyAppLayout from 'components/shopifyApp/ShopifyAppLayout'
import styled from 'styled-components'
import moment from 'moment'
import keys from 'lodash/keys'
import get from 'lodash/get'

import UICard from '../shopifyApp/shopifyWizard/shopifyUI/UICard'
import { SHOPIFY_GRAY } from 'components/styles'
import Breadcrumbs from '../shopifyApp/shopifyWizard/shopifyUI/Breadcrumbs'
import DateRangePicker from '../shopifyApp/shopifyWizard/shopifyUI/DateRangePicker'
import { changeEditorScene } from 'actions/locationAC'

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${SHOPIFY_GRAY};
  font-size: 14px;
  line-height: 1;
  padding-left: 56px;
  padding-top: 30px;
  overflow: scroll;
`
const HeaderWrapper = styled.div`
  margin-top: 1em;
`
const DateRangePickerWrapper = styled.div`
  margin-top: 1.1em;
`
const TextWrapper = styled.div`
  margin-top: 1.1em;
`
const CardsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-flow: row wrap;
`
const CardWrapper = styled.div`
  margin-right: 1.5em;
  margin-top: -0.4em;
`
const CardContainer = styled.div`
  line-height: 2;
  padding-top: 1.8em;
  padding-bottom: 1.5em;
  padding-left: 0.5em;
`
const CardTitle = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 1;
`
const CardContent = styled.div`
  font-weight: 600;
  font-size: 2em;
  line-height: 2;
`
const cardLayoutConf = {
  width: '497px',
  top: '2em'
}
const BannerWrapper = styled.div`
  font-size: 10px;
  margin-bottom: 2em;
`
const BannerText = styled.div`
  font-size: 1.4em;
`
const SpinnerWrapper = styled(CardContainer)`
  display: flex;
  padding-top: 3.5em;
  padding-bottom: 2em;
  justify-content: center;
  font-size: 10px;
`
const StackWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`
const StackContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
`
const ButtonSpinner = styled.div`
  padding-left: 0.5em;
`

class ShopifyDashboard extends Component {
  constructor (props) {
    super(props)
    this.state = {
      publishProcessing: false
    }
    this.goLive = this.goLive.bind(this)
    this.renderPublishBanner = this.renderPublishBanner.bind(this)
  }

  componentWillMount () {
    const { apps, shopifyAnalytics, dispatch } = this.props
    dispatch(initShopifyDashboard(keys(apps)[0]))
    let { datesRange } = shopifyAnalytics
    if (!datesRange) {
      datesRange = getDefaultAnalyticsDateRange()
      dispatch(setAnalyticsDatesRange(datesRange))
    }
    dispatch(fetchAnalytics(datesRange))
    dispatch(changeEditorScene(0))
  }

  componentWillReceiveProps (nextProps) {
    const status = get(nextProps, 'user.status')
    if (status === 'declined' || status === 'activated') {
      this.setState({
        publishProcessing: false
      })
    }
  }

  renderCardContent (title, value) {
    return (
      <CardContainer>
        <CardTitle>{title}</CardTitle>
        <CardContent>{value}</CardContent>
      </CardContainer>
    )
  }

  renderSpinner = () => (
    <SpinnerWrapper>
      <Spinner size='large' color='teal' />
    </SpinnerWrapper>
  )

  renderCard (title, value) {
    const field = {
      ...cardLayoutConf
    }
    return (
      <CardWrapper>
        <UICard
          title=''
          content={value !== null ? this.renderCardContent(title, value) : this.renderSpinner()}
          width={field.width}
          height={field.height}
          top={field.top}
        />
      </CardWrapper>
    )
  }

  breadcrumbsHandler = () => {
    const { apps } = this.props
    const appId = keys(apps)[0]
    gotoEditor(appId)
  }

  renderTrialInfoBanner () {
    const { user, shopifyPlans, references } = this.props
    if (!user.publishedFirstAt) return null
    const activePlanId = user.activePlanId || references.defaultShopifyPlanId
    const plan = get(shopifyPlans, ['plans', activePlanId])
    if (plan) {
      const trialDays = plan.trialDays
      const trialEnds = new Date(user.publishedFirstAt)
      trialEnds.setDate(trialEnds.getDate() + trialDays)
      const oneDay = 24 * 60 * 60 * 1000
      const trialDaysLeft = Math.max(0, Math.round(Math.abs((trialEnds.getTime() - Date.now()) / oneDay)))
      if (trialDaysLeft === 0) return null
      const trialEndsStr = moment(trialEnds).format('MMMM Do, YYYY')
      return (
        <BannerWrapper>
          <Banner title={`You have ${trialDaysLeft} days left on your free trial`} status='warning'>
            <BannerText>{`30-day recurring app billing cycle starts on ${trialEndsStr}. Recurring charge will be added to shop's next invoice`}</BannerText>
          </Banner>
        </BannerWrapper>
      )
    }
  }

  goLive () {
    const { apps, dispatch } = this.props
    const appId = keys(apps)[0]
    console.log('appId', appId)
    this.setState({publishProcessing: true})
    dispatch(publishAndActivate(appId))
  }

  renderPublishBanner () {
    const banner = () => (<BannerText>{'Publish to my store'}</BannerText>)
    const stack = () => (
      <StackWrapper>
        <StackContent>
          {banner()}
          <ButtonSpinner>
            <Spinner color='white' size='small' />
          </ButtonSpinner>
        </StackContent>
      </StackWrapper>
    )
    const action = this.state.publishProcessing ? {content: stack()} : {content: banner(), onAction: this.goLive}
    return (
      <BannerWrapper>
        <Banner
          title='Your Whimm is not published'
          action={action}
          status='critical'>
          <BannerText>{'Publish now to your shopify mobile website to start boosting conversions'}</BannerText>
        </Banner>
      </BannerWrapper>
    )
  }

  renderBanner () {
    const { user } = this.props
    if (user.publishedFirstAt && user.status === 'activated') {
      return this.renderTrialInfoBanner()
    } else {
      return this.renderPublishBanner()
    }
  }

  renderBody () {
    const { shopifyAnalytics, user } = this.props

    const whimmOrders = get(shopifyAnalytics, 'data.whimmOrdersCount', null)
    const noWhimmOrders = get(shopifyAnalytics, 'data.noWhimmOrdersCount', null)
    const activated = get(user, 'status') === 'activated'

    const renderContent = () => (
      activated
      ? (<div>
        <DateRangePickerWrapper>
          <DateRangePicker />
        </DateRangePickerWrapper>
        <CardsContainer>
          {this.renderCard('Total orders from mobile with Whimm', whimmOrders)}
          {this.renderCard('Total orders from mobile without Whimm', noWhimmOrders)}
        </CardsContainer>
      </div>)
      : (<TextWrapper>
        <TextContainer>Will be available after publishing your Whimm</TextContainer>
      </TextWrapper>)
    )

    return (
      <Wrapper>
        {this.renderBanner()}
        <Breadcrumbs title='Whimm' handler={this.breadcrumbsHandler} />
        <HeaderWrapper>
          <DisplayText size='extraLarge'>Whimm analytics</DisplayText>
        </HeaderWrapper>
        { renderContent() }
      </Wrapper>
    )
  }

  renderContent () {
    return (
      <ShopifyAppLayout
        body={this.renderBody()}
      />
    )
  }

  render () {
    const { shopifyAuth } = this.props
    if (shopifyAuth.apiKey && shopifyAuth.shopUrl) {
      return (
        <EmbeddedApp
          apiKey={shopifyAuth.apiKey}
          shopOrigin={`https://${shopifyAuth.shopUrl}`}
        >
          {this.renderContent()}
        </EmbeddedApp>
      )
    } else {
      return this.renderContent()
    }
  }
}

ShopifyDashboard.propTypes = {
  shopifyAuth: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  shopifyAnalytics: PropTypes.object.isRequired,
  shopifyPlans: PropTypes.object.isRequired,
  references: PropTypes.object.isRequired,
  apps: PropTypes.object.isRequired
}

const mapStateToProps = (state) => ({
  shopifyAuth: state.shopifyAuth,
  user: state.user,
  shopifyAnalytics: state.shopifyAnalytics,
  shopifyPlans: state.shopifyPlans,
  references: state.references,
  apps: state.apps
})

export default connect(mapStateToProps)(ShopifyDashboard)



// WEBPACK FOOTER //
// ./src/components/pages/ShopifyDashboard.js